import React from "react";

function ImageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.75"
      height="19.75"
      viewBox="0 0 19.75 19.75"
    >
      <path
        id="Path_22547"
        data-name="Path 22547"
        d="M5.194,11.888,7.389,9.693l6.035,6.035,3.84-3.84,3.292,3.292V5.194H5.194ZM4.1,3H21.652a1.1,1.1,0,0,1,1.1,1.1V21.652a1.1,1.1,0,0,1-1.1,1.1H4.1a1.1,1.1,0,0,1-1.1-1.1V4.1A1.1,1.1,0,0,1,4.1,3Zm12.618,7.68a1.646,1.646,0,1,1,1.646-1.646A1.646,1.646,0,0,1,16.715,10.68Z"
        transform="translate(-3 -3)"
        fill="#fff"
      />
    </svg>
  );
}

export default ImageIcon;
